import React from 'react';
import './ReferencedataShow.css';
import { Input, Drawer, Select } from 'antd';
const { TextArea } = Input;
const ReferencedataShow = ({
    isListOutputData,
    handleOutPutListClick,
    editOutputData,
}) => {
    const SideClose = '/assets/ModalClose.svg';
    return (
        <>
            <Drawer
                placement='right'
                closable={false}
                onClose={handleOutPutListClick}
                open={isListOutputData}
                key='right'
                width={'40%'}>
                <img
                    className='reference-data-side-close'
                    src={SideClose}
                    alt=''
                    onClick={handleOutPutListClick}
                />
                <div className='reference-data-modal-div'>
                    <h3>Supporting Document</h3>
                </div>
                <div className='supporting-document-1'>
                    <label className='reference-label'>
                        Supporting Document name
                    </label>
                    <Input
                        className='mb-2'
                        placeholder='Enter your name'
                        value={editOutputData?.name}
                    />
                </div>
                <div className='supporting-document-2'>
                    <label className='reference-label'>
                        Context to frame reference data (edit if required)
                    </label>
                    <Input
                        className='mb-2'
                        placeholder='Enter your context'
                        value={editOutputData?.context}
                    />
                </div>
                {editOutputData.type === 'text' ? (
                    <div className='reference-data-2'>
                        <label className='reference-label'>
                            Reference data
                        </label>
                        <TextArea
                            className='mb-2'
                            rows={4}
                            value={editOutputData?.data}
                        />
                    </div>
                ) : null}
                {editOutputData.type === 'file' &&
                    editOutputData?.files?.length > 0 && (
                        <div>
                            {editOutputData?.files.map((document, index) => (
                                <div key={index} className='reference-data-2'>
                                    <label className='reference-label'>
                                        Reference data
                                    </label>
                                    <div className='upload-computer-img-height-320'>
                                        <div className='upload-computer-main-div'>
                                            <div className='upload-computer-span'>
                                                <div className='upload-computer-middle-div-first-p'>
                                                    File Name:{' '}
                                                    {document?.filename}
                                                </div>
                                                <div className='upload-computer-middle-div-second-p'>
                                                    Word Count:{' '}
                                                    {new Intl.NumberFormat().format(
                                                        document?.word_count
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='upload-computer-main-content'>
                                        <p>{document?.content}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                {editOutputData.type === 'url' ? (
                    <>
                        <div className='website-url-modal-div'>
                            <h3>Live reference data</h3>
                            <label>Set-up URL to monitor</label>
                        </div>
                        <div className='website-url-input'>
                            <div className='website-url-1'>
                                <label>
                                    Scrape a website using the Top Level Domain
                                </label>
                                <Input
                                    className='mb-2'
                                    placeholder='Enter your top_domain'
                                />
                            </div>
                            <div className='website-url-2'>
                                <label>
                                    List any URLs you do not want to scrape on
                                    this website
                                </label>
                                <Input
                                    className='mb-2'
                                    placeholder='Enter your exclude_urls'
                                />
                            </div>
                        </div>
                        <div className='website-url-modal-div'>
                            <h3>Or</h3>
                        </div>
                        <div className='website-url-input'>
                            <div className='website-url-1'>
                                <label>Scrape a single URL</label>
                                <Input
                                    className='mb-2'
                                    placeholder='Enter your single_url'
                                />
                            </div>
                            <div className='website-url-2'>
                                <label>Frequency</label>
                                <Select
                                    className='mb-2'
                                    options={[
                                        { value: 'off', label: 'off' },
                                        { value: 'once', label: 'once' },
                                        {
                                            value: 'quarterly',
                                            label: 'quarterly',
                                        },
                                        { value: 'monthly', label: 'monthly' },
                                        { value: 'weekly', label: 'weekly' },
                                        { value: 'daily', label: 'daily' },
                                    ]}
                                />
                            </div>
                        </div>
                    </>
                ) : null}
            </Drawer>
        </>
    );
};
export default ReferencedataShow;
